"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectFormat = detectFormat;
exports.getFormatById = getFormatById;
exports.importFormats = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
var _defaultFormat = require("./default-format");
var importFormats = exports.importFormats = [_defaultFormat.defaultFormat];

/**
 * Excelヘッダー名の配列からフォーマットを自動検出する。
 * 各フォーマットのフィールド定義とヘッダー名のマッチ率を比較し、
 * 最もマッチ率が高いフォーマットを返す。
 *
 * @param {string[]} headers - Excelファイルのヘッダー名配列
 * @returns {Object|null} 検出されたフォーマット、またはマッチしない場合 null
 */
function detectFormat(headers) {
  var best = null;
  var bestRate = 0;
  importFormats.forEach(function (format) {
    var formatHeaders = format.fields.map(function (f) {
      return f.header;
    });
    var matched = headers.filter(function (h) {
      return formatHeaders.indexOf(h) !== -1;
    });
    var rate = matched.length / formatHeaders.length;
    if (rate > bestRate) {
      bestRate = rate;
      best = format;
    }
  });
  return bestRate >= 0.5 ? best : null;
}

/**
 * IDでフォーマットを取得する。
 *
 * @param {string} id - フォーマットID
 * @returns {Object|undefined}
 */
function getFormatById(id) {
  return importFormats.find(function (f) {
    return f.id === id;
  });
}